import script from "./UserPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPage.vue?vue&type=script&setup=true&lang=ts"

import "./UserPage.vue?vue&type=style&index=0&id=41b67d34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41b67d34"]])

export default __exports__